import { ViewModel,View } from "binder"
import  { ImageEditorView } from "./imageEditor-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class ImageEditorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ImageEditorView();
    }
    public getTypeId(): string {
        return "VM-4FF6053B-D6CB-4430-98C4-F69DB512D075"
    }
    
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

    setValue(v: string) {
        if(v && v.startsWith('url(') && v.endsWith(')')){
            this.value = v.slice(4,-1);
        }else{
            this.value = v;
        }
    }
    getValue(): string {
        if(stringIsNullOrEmpty(this.value)){
            return this.value;
        }
        return `url(${this.value})`;
    }
    requestConfirm() {
    }
}
